export const APP_NAME = 'DPSHTRR Asist';

export const AVATAR_SRC = '/dpshtrr-chat-avatar.jpg';

export const WELCOME_MESSAGE =
  'Unë jam asistentja virtuale për shërbimet e Drejtorisë së Përgjithshme të Shërbimeve të Transportit Rrugor.';

export const QUICK_PROMPTS = [
  { text: 'Si të rinovoj patentën?', icon: '🪪', tone: 'violet' },
  { text: 'Regjistrim mjeti', icon: '🚗', tone: 'blue' },
  { text: 'Targa', icon: '🔢', tone: 'teal' },
  { text: 'Kontroll teknik', icon: '🔧', tone: 'navy' }
];

export const CHAT_DISCLAIMER_LINES = [
  'Jam këtu për të ofruar informacion orientues për navigim në faqen web të DPSHTRR dhe përditësohem vazhdimisht.',
  'Nëse informacioni i ofruar nuk i përgjigjet plotësisht rastit tuaj, ju lutemi na telefononi në numrin e publikuar më poshtë për asistencë'
];

export const FOOTER_PHONE = '0800 85 85';
export const FOOTER_PHONE_HREF = 'tel:08008585';
export const FOOTER_SITE = 'https://www.dpshtrr.al';

export const INPUT_MAX_HEIGHT_PX = 120;
export const SCROLL_BOTTOM_THRESHOLD_PX = 120;
